// 10.9.2025

import $ from 'jquery';
import Flickity from 'flickity';
import Cookies from 'js-cookie';

import ajaxCart from './modules/ajax-cart';
import backgroundVideo from './modules/backgroundvideo';
import shopifyMoney from './modules/money';
import recentlyViewed from './modules/recentlyviewed';

import productPage from './pages/product';
import defaultPage from './pages/default';
import customerPage from './pages/customer';
import collectionPage from './pages/collection';
import blogPage from './pages/blog';

window.Flickity = Flickity;
window.$ = $;
window.jQuery = $;

window.touch = ('ontouchstart' in window) ||
  (navigator.maxTouchPoints > 0) ||
  (navigator.msMaxTouchPoints > 0);

$('html').addClass(window.touch ? 'touch' : '');

$(function () {

  const money = new shopifyMoney();
  money.init();

  const cart = new ajaxCart();
  cart.init();

  const rec = $('[data-section-id="recently-viewed-products"]');
  if (rec.length > 0) {
    const recents = new recentlyViewed(rec);
  }
  // recents.init();

  cooks();

  binds();

  if ($('.slideshow .invert-true').length > 0) {
    checkInvertHero();
    setTimeout(function () {
      $('body').addClass('trans-headers');
    }, 1);
  }

  $(window).on('load pageshow', function () {
    $(window).trigger('scroll');
  });

  setTimeout(function () {
    $(window).trigger('scroll');

    setTimeout(function () {
      $(window).trigger('scroll');
    }, 2000)
  }, 1000)

  if (Shopify.designMode) {
    // This will only render in the theme editor
  }


  if (window.location.href.indexOf('/collections/') > 0) {
    $('.header .menu-item a[href*="/collections/"]').parent('li').addClass('is-active');
  }

  if ($('.products-list--item').length > 0) {
    if (window.location.hash == '#index') {
      $('.collection-list').css('opacity', 0);
    }

    const page = new collectionPage();
    page.init();
  }

  $('.videoblock:not(.mp4)').each(function () {
    new backgroundVideo(this);
  });

  if ($('.default-page').length > 0) {
    const page = new defaultPage();
    page.init();
  }

  if ($('#wrap.blog').length > 0) {
    const page = new blogPage();
    page.init();
  }

  if ($('.single-product').length > 0) {
    const product = new productPage();
    product.init();

    $('.large-view--content').on('scroll', function () {
      checkHires();
    });
  }

  if ($('#wrap[class*="customer"]').length > 0) {
    const customer = new customerPage();
    customer.init();
  }

  if ($('#wrap.cart').length > 0) {
    $('#mini-cart').appendTo('main').removeClass('hc-mini');
    $('.cart-tog').unbind('click').click(function (e) {
      e.preventDefault();
      window.location.href = window.location.href;
    });
  }

  if ($('#wrap.search').length > 0) {
    $('#ajaxsearch').appendTo('main').addClass('searchpage');
    $('#ajaxsearch input[type="text"]').attr('autofocus', 'autofocus');
    $('#ajaxsearch input[type="text"]').focus();
    $('#ajaxsearch input[type="text"]').click();
    // $('#ajaxsearch input[type="text"]').get(0).setSelectionRange(0, 0);
  }

  if (window.touch) {
    $('.product-item--image .first-false').remove();
  }

  if (window.innerWidth <= 767) {
    $('video.deskonly').remove();
  } else {
    $('video.mobonly').remove();
  }

  $(window).on('load', function () {
    checkHires();
  });

  $(window).on('scroll', function () {
    checkHires();
  });
});

function cooks() {
  if (Cookies.get('announcement') != 'done' && $('#section-announcement').length > 0) {
    $('body').addClass('has-announcement');
    $('#section-announcement').removeClass('out');
  }
}

function binds() {
  if ($('.floating-header').length > 0) {
    var floater = $('.floating-header').get(0);
    var floaterSects = [];
    $('.collection-sidebar--title').each(function (idx) {
      var par = $(this).parents('.shopify-section');
      par.id = $(par).attr('data-section-id');
      floaterSects.push(par);
      $(par).addClass('hide-header');
      if (idx == 0) {
        floater.cur = par.id;
        $(par).removeClass('hide-header');
      }
    });

    $(window).unbind('scroll').scroll(function () {
      if (window.innerWidth > 767) {
        var anythinginview = false;
        for (var i = 0; i < floaterSects.length; i++) {
          var par = $(floaterSects[i]).get(0);
          var rect = par.getBoundingClientRect();
          var inview = rect.top < window.innerHeight * .5 && rect.bottom > window.innerHeight * .5;
          var cur = par.id == floater.cur;

          if (inview && !cur) {
            console.log('should swap!');
            floater.cur = par.id;
            $(floater).html($(par).find('.collection-sidebar--title').html());
          }
          if (inview) {
            anythinginview = true;
          }
        }

        if (!anythinginview) {
          $('#' + floater.cur).removeClass('hide-header');
          $(floater).hide();
        } else {
          //$('#'+floater.cur).removeClass('show-header');
          $(floaterSects).each(function () {
            $(this).addClass('hide-header');
          });
          $(floater).show();
        }
      }
    });
  }

  if ($('.slideshow .invert-true').length > 0) {
    $(window).scroll(function () {
      checkInvertHero();
    });

    $('.slideshow--carousel').on('change.flickity', function () {
      checkInvertHero();
    });
  }

  $('.slideshow--scrollbutton').unbind('click').click(function (e) {
    var h = $('.shopify-section--slideshow').outerHeight();
    $('html, body').animate({ 'scrollTop': h }, 500);
  });

  $('.collection-sidebar--toggle').click(function (e) {
    e.preventDefault();
    $('.collection-sidebar').slideToggle(150).toggleClass('in');
    if ($('.collection-sidebar').hasClass('in')) {
      if ($(this).children('span').find('em').length > 0) {
        $(this).children('span').find('em').text(window.themeStrings.close ? window.themeStrings.close : 'Close');
      } else {
        $(this).children('span').text(window.themeStrings.close ? window.themeStrings.close : 'Close');
      }
    } else {
      $(this).children('span').html($(this).children('span').attr('data-title'));
    }
  });

  $('.mobile-menu--trigger').click(function (e) {
    e.preventDefault();
    $('.mobile-menu').toggleClass('in');
    if ($('.mobile-menu').hasClass('in')) {
      $(this).children('span').text(window.themeStrings.close ? window.themeStrings.close : 'Close');
      window.prevscroll = $(window).scrollTop();
      $(window).scrollTop(0);
      $('html').addClass('noscr');
      setTimeout(function () {
        $('html').addClass('noscr');
      }, 1);
    } else {
      $(this).children('span').text('Menu');
      $('html').removeClass('noscr');
      $(window).scrollTop(window.prevscroll);
      setTimeout(function () {
        $(window).scrollTop(window.prevscroll);
      }, 1);
      setTimeout(function () {
        $(window).scrollTop(window.prevscroll);
      }, 5);
    }
  });

  $('.search-tog').click(function (e) {
    e.preventDefault();
    if ($('#wrap.search').length == 0) {
      $('#ajaxsearch').toggleClass('in');
      if ($('#ajaxsearch').hasClass('in')) {
        $('.search-tog').addClass('act');
        $('.search-box--form input[type="text"]').focus();
        if (window.heroInvert) {
          $('body').removeClass('heroinvert');
        }
      } else {
        $('.search-tog').removeClass('act');
        if (window.heroInvert) {
          $('body').addClass('heroinvert');
        }
      }
    } else {
      // $('.search')
      $('.search-box--form input[type="text"]').val('').trigger('change')
      $('.search-box--form input[type="text"]').focus();
    }
  });

  $('.announcement--close').click(function (e) {
    e.preventDefault();
    $('body').removeClass('has-announcement');
    $('#section-announcement').addClass('out');
    Cookies.set('announcement', 'done', { expires: 1 }); // 10sec: 0.000115740741
  });

  $('.thumb-image').unbind('click').click(function (e) {
    e.preventDefault();
    var st = $(this).attr('style');
    var target = $('.single-product--image[style="' + st + '"]');
    var pos = $(target).offset().top;
    $('html, body').animate({ 'scrollTop': pos }, 400);
  });

  if (!window.touch) {
    $('.product-item--images').unbind('mousemove mouseleave').on('mousemove', function (e) {
      var l = e.offsetX;
      var w = this.getBoundingClientRect().width;
      var prc = l / w;
      var imglen = $(this).children().length;
      var sel = Math.floor(prc * imglen);
      var selimg = $(this).children().eq(sel);
      $(this).children().removeClass('hov');
      $(selimg).addClass('hov');
    }).on('mouseleave', function () {
      $(this).children().removeClass('hov');
    });
  }

  $('a.back').click(function (e) {
    e.preventDefault();
    window.history.back();
  });
}

function checkInvertHero() {
  if ($('.slideshow--slide.is-selected').hasClass('invert-true')) {
    if ($('.slideshow--slide.is-selected.invert-true').get(0).getBoundingClientRect().bottom > 0) {
      $('body').addClass('heroinvert');
      window.heroInvert = true;
    } else {
      $('body').removeClass('heroinvert');
      window.heroInvert = false;
    }
  } else {
    $('body').removeClass('heroinvert');
    window.heroInvert = false;
  }
}

function checkHires() {
  $('.hires:not(.in):not(.loading), video:visible source[data-src]:not(.loading)').each(function () {
    if (this.getBoundingClientRect().top < window.innerHeight * 1.5) {
      var url = $(this).attr('data-src');
      $(this).addClass('loading');
      $(this).removeAttr('data-src');
      // $(this).attr('data-src','');
      if ($(this).is('source')) {
        console.log(url);
        $(this).attr('src', url);
        if ($(this).siblings('[data-src]').length == 0) {
          $(this).parent('video').get(0).load();
        }
      } else {
        var img = this;
        img.src = url;
        img.onload = function () {
          if ($(img).attr('data-srcset')) {
            $(img).attr('srcset', $(img).attr('data-srcset'));
            $(img).attr('data-srcset', '');
          }
          $(img).removeClass('loading').addClass('in');
          $(img).siblings('.lores').addClass('ok');
        }
      }
    }
  });
}
